import { nativeMethodCall } from '@/tools/nativeInterface';
import logger from '@/tools/logger';
import { actionTypes, errorTypes } from '@/types';

export default function openUrl({ state, dispatch }, { url, target }) {
	if (!url) {
		logger.warn('openUrl with empty url');
		return;
	}
	// The URL is an article id or `auto-exhibtions`
	if (/^..\/[a-f0-9A-F]{24}/.test(url) || /^..\/auto-/.test(url)) {
		dispatch(actionTypes.setExhibition, {
			exhibitionID: state.currentExhibitionID,
			articleID: url.slice(3, url.length),
		});
	}

	// The URL is of type `command:` or of type `http`
	if (/^[a-z]+:[0-9]*/.test(url)) {
		if (/^command:\/\//.test(url)) {
			dispatch(actionTypes.executeCommandString, url);
			return;
		}

		if (/^http[s]*:[0-9]*\/\//.test(url) || /^mailto:/.test(url)) {
			if (state.isApp) nativeMethodCall({ method: 'nativeContentOpen', params: [url] });
			else window.open(url, target);
		}
	}
	// The URL start with a `/`
	else if (/^\//.test(url)) {
		// Let URLs that start with a `/` open in the current window/tab
		// so we can open urls like `/captivelogin/?redirect=market://details?id=com.shoutrlabs.shoutrboxxapp`
		window.open(url, '_self');
	}
	// The URL starts with `function`
	else if (/\[function\]/.test(url)) {
		logger.log('Link calls internal function');
	}
	// This is an unknown URL pattern, throw an error.
	else {
		throw new Error(errorTypes.unknownLinkPattern);
	}
}
